import { AppShell, Burger, Box, MantineProvider } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useIsFetching } from "@tanstack/react-query";
import { Sidebar } from "./components/Sidebar/Sidebar";
import { DeckMap } from "./components/Map/DeckMap";
import { ValidationModal } from "./components/ValidationModal";
import { HindcastInfoModal } from "./components/HindcastInfoModal";
import { SatelliteInfoModal } from "./components/SatelliteInfoModal";
import { useSpinningFavicon } from "./hooks/useSpinningFavicon";
import { useTour } from "./hooks/useTour";

const SIDEBAR_WIDTH = 300;

export function App() {
  const [opened, { toggle, close }] = useDisclosure(false);

  const fetchingGridstats = useIsFetching({ queryKey: ["gridstats"] });
  const fetchingValidation = useIsFetching({ queryKey: ["validate"] });
  useSpinningFavicon(!!(fetchingGridstats || fetchingValidation));
  useTour();

  return (
    <AppShell
      navbar={{ width: SIDEBAR_WIDTH, breakpoint: "sm", collapsed: { mobile: !opened } }}
      padding={0}
      styles={{
        root: { height: "100vh", overflow: "hidden" },
        navbar: {
          overflowY: "auto",
          padding: "var(--mantine-spacing-md)",
          background: "#0d2e40",
          borderRight: "1px solid rgba(255,255,255,0.07)",
        },
        main: { padding: 0, height: "100vh" },
      }}
    >
      <AppShell.Navbar>
        <MantineProvider forceColorScheme="dark">
          <Sidebar onClose={close} />
        </MantineProvider>
      </AppShell.Navbar>

      <AppShell.Main>
        {/* Burger button — floats over the map, mobile only */}
        <Box
          hiddenFrom="sm"
          pos="absolute"
          top={12}
          left={12}
          style={{ zIndex: 200 }}
        >
          <Burger
            opened={opened}
            onClick={toggle}
            size="sm"
            color="white"
            styles={{
              root: {
                background: "rgba(0,0,0,0.5)",
                borderRadius: "var(--mantine-radius-sm)",
                padding: "var(--mantine-spacing-xs)",
              },
            }}
          />
        </Box>
        <DeckMap onMapClick={close} />
      </AppShell.Main>

      {/* Modals */}
      <ValidationModal />
      <HindcastInfoModal />
      <SatelliteInfoModal />
    </AppShell>
  );
}
